import litigantMenuConstants from "../constants/litigantMenuConstants";

const litigantMenu = (state = {}, action) => {
  //console.log("Litgiant reducer");
  switch (action.type) {
    case litigantMenuConstants.REQUEST_MENU_OPTIONS:
      return {
        ...state,
        litigantMenuOptions: action.payload
      };
    case litigantMenuConstants.REQUEST_MENU_OPTIONS_SUCCESS:
      return {
        ...state,
        litigantMenuOptions: action.payload
      };
    case litigantMenuConstants.REQUEST_MENU_OPTIONS_FAILURE:
      return {};
    default:
      return state;
  }
};

export default litigantMenu;
